import React from "react";
import { Col, Typography } from "antd";
import { ReactComponent as ArrowIcon } from "../../../assets/icons/arrow-right.svg";
import "../contentcard.css";

export const ReturnExchange = (props) => {
  const { data } = props;
  const { Text } = Typography;
  return (
    <>
      <Col className="rejected-card-container">
        {data?.map((val, idx) => (
          <Col key={idx} className="rejected-card-data-container">
            <Col className="rejected-card-data-sub-container">
              <Col className="rejected-card-status-container">
                <Col>{val.image}</Col>
                <Col className="rejected-card-data-sub-id-container">
                  <Text className="rejected-card-data-sub-id-text">
                    {val.id}
                  </Text>
                  <Text className="rejected-card-data-sub-name-text">
                    {val.date}
                  </Text>
                </Col>
              </Col>
              <Col className="item-issues-sub-name-container">
                <Col className="return-exchange-icon-container">
                  <Col>{val.icon}</Col>
                  <Text className="rejected-card-amount-sub-text-item">
                    {val.task}
                  </Text>
                </Col>
                <Col className="rejected-card-status-container">
                  <Col className="return-exchange-card-status-sub-container">
                    {val.status}
                  </Col>
                  <ArrowIcon />
                </Col>
              </Col>
            </Col>
          </Col>
        ))}
      </Col>
    </>
  );
};
